const fonts = {
  body: `var(--font-poppins)`,
  heading: `var(--font-poppins)`,
  mono: 'Menlo, monospace',
};
export default fonts;
